<template>
  <div
    v-show="isActive"
    class="bulma-message-modal">
    <div
      class="bulma-message-modal-backdrop"
      @click="handleBackdropClick" />

    <article
      class="message bulma-message-modal-panel"
      :class="type + ' ' + ($theme.isDark ? 'is-dark' : 'is-light')">
      <header
        v-if="hasHeader"
        class="message-header is-flex is-justify-content-space-between">
        <span class="is-flex is-align-items-center">
          <span class="msr msr-24px mr-2"
            :style="{ color: iconColorCode || '' }">{{ iconName }}</span>
          <slot name="title">
            {{ title }}
          </slot>
        </span>
        <span v-if="closable">
          <span class="msr msr-24px mr-2 is-flex is-align-items-center is-cursor-pointer"
            @click="close">close</span>
        </span>
        <!-- <button
          v-if="closable"
          class="delete ml-auto"
          aria-label="close"
          @click="close" /> -->
      </header>

      <section class="message-body">
        <slot />
        <div
          class="bulma-message-modal-footer pt-5 pb-0 px-0">
          <slot name="footer">
            <button
              class="button is-primary"
              type="button"
              @click="close">
              Dismiss
            </button>
          </slot>
        </div>
      </section>
    </article>
  </div>
</template>

<script>
import { BulmaMessageType } from '@/enums'

export default {
  name: 'BulmaMessage',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Message'
    },
    type: {
      type: String,
      default: BulmaMessageType.Info
    },
    closable: {
      type: Boolean,
      default: true
    },
    canCancelOnBackdrop: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null
    },
    iconColor: {
      type: String,
      default: null
    }
  },
  computed: {
    isActive: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    hasHeader() {
      return !!this.title || !!this.$slots.title || this.closable
    },
    iconName() {
      if (this.icon) {
        return this.icon
      }
      const iconMap = {
        [BulmaMessageType.Danger]: 'error',
        [BulmaMessageType.Warning]: 'warning',
        [BulmaMessageType.Success]: 'check_circle',
        [BulmaMessageType.Info]: 'info',
        [BulmaMessageType.Primary]: 'info'
      }
      return iconMap[this.type] || 'info'
    },
    iconColorCode() {
      return (this.iconColor) ? this.iconColor : '#FFCC00' //amber
    }
  },
  methods: {
    close() {
      this.isActive = false
      this.$emit('close')
    },
    handleBackdropClick() {
      if (!this.canCancelOnBackdrop) return
      this.close()
    }
  }
}
</script>

<style scoped>
.bulma-message-modal {
  position: fixed;
  inset: 0;
  z-index: 40;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bulma-message-modal-backdrop {
  position: absolute;
  inset: 0;
  background-color: var(--message-backdrop-bg);
}

.bulma-message-modal-panel {
  position: relative;
  z-index: 41;
  max-width: 640px;
  width: 90%;
  max-height: 90vh;
  overflow: auto;
}

.bulma-message-modal-footer {
  padding: 0.75rem 1rem 1rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

.message.is-light .message-header {
  background-color: var(--message-header-light-bg);
  color: var(--message-header-light-color);
}
.message.is-dark .message-header {
  background-color: var(--message-header-dark-bg);
  color: var(--message-header-dark-color);
}
.message.is-light .message-body {
  background-color: var(--message-body-light-bg);
  color: var(--message-body-light-color);
}
.message.is-dark .message-body {
  background-color: var(--message-body-dark-bg);
  color: var(--message-body-dark-color);
}

.is-cursor-pointer {
  cursor: pointer;
}
</style>

